import { render, staticRenderFns } from "./HeadGate.vue?vue&type=template&id=bffc3a34&scoped=true"
import script from "./HeadGate.vue?vue&type=script&lang=js"
export * from "./HeadGate.vue?vue&type=script&lang=js"
import style0 from "./HeadGate.vue?vue&type=style&index=0&id=bffc3a34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bffc3a34",
  null
  
)

export default component.exports